    var momentFormat = function(date) {
      return moment(date).format('dd/MM/yyyy');
    }


// WEBPACK FOOTER //
// ./resources/assets/js/components/util/MomentFormat.js